"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SalesOrderSummaryInfo = void 0;
const React = require("react");
const TSalesOrderType_1 = require("../../../types/TSalesOrderType");
const SalesOrderSummaryDriverDetails_1 = require("../SalesOrderSummaryDriverDetails");
const SalesOrderSummaryDetails_1 = require("../SalesOrderSummaryDetails");
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../../../helpers/cssComposer");
const css = (0, cssComposer_1.default)(styles, "SalesOrderSummaryInfo");
const SalesOrderSummaryInfo = ({ salesOrder }) => {
    const { type } = salesOrder;
    return (React.createElement("div", { className: css("") },
        React.createElement("div", { className: css("body") },
            type === TSalesOrderType_1.TSalesOrderType.Delivery && (React.createElement(SalesOrderSummaryDriverDetails_1.SalesOrderSummaryDriverDetails, { salesOrder: salesOrder, type: "desktop" })),
            React.createElement(SalesOrderSummaryDetails_1.SalesOrderSummaryDetails, { salesOrder: salesOrder }))));
};
exports.SalesOrderSummaryInfo = SalesOrderSummaryInfo;
//# sourceMappingURL=index.js.map